export default import.meta.ROLLUP_FILE_URL_SH3JcDOvWNcn2WIvxBnLpg;